// Module
var code = "<select :id=\"id\" v-bind:multiple=\"multiSelect\" :disabled=\"disabled\" ref=\"selectElement\"/>";
// Exports
module.exports = code;